const legacyPathTargets: Record<string, { path: string; view?: string }> = {
  '/': { path: '/v1/signin' },
  '/dashboard': { path: '/v1/app/dashboard' },
  '/settings': { path: '/v1/settings' },
  '/sheets': { path: '/v1/app/dashboard', view: 'sheet' },
  '/api-docs': { path: '/v1' },
  '/mcp-docs': { path: '/v1' },
  '/success': { path: '/v1/billing/success' },
  '/cancel': { path: '/v1/billing/cancel' },
  '/cancel-successful': { path: '/v1/settings' },
  '/preview': { path: '/v1/signin' },
  '/preview/bank-connection': { path: '/v1' },
  '/preview/settings': { path: '/v1/settings' },
  '/preview/mysheets': { path: '/v1/app/dashboard', view: 'sheet' },
  '/preview/success': { path: '/v1/billing/success' },
  '/preview/cancel': { path: '/v1/billing/cancel' },
}

/**
 * Map old application URLs to V1 while preserving OAuth, checkout, and bookmark state.
 *
 * Returns null for a path the app never had, so the caller can show a 404 rather
 * than dropping a mistyped URL into the app. Anything under /preview still goes
 * to V1: that whole area was the old app, so an unlisted page there is a stale
 * bookmark, not a typo.
 */
export function retiredRouteTarget(pathname: string, search = '', hash = ''): string | null {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
  const target =
    legacyPathTargets[normalizedPath] ??
    (normalizedPath.startsWith('/preview/') ? { path: '/v1' } : null)
  if (!target) return null
  const params = new URLSearchParams(search)

  // The old manual-registration switch has no meaning in V1, which uses Google sign-in only.
  params.delete('oneOffReg')
  if (target.view) params.set('view', target.view)

  const query = params.toString()
  return `${target.path}${query ? `?${query}` : ''}${hash}`
}
